// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dc737e83","885":"a7708f90","977":"c72b85d8"}[chunkId] + ".chunk.js";
};